var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOval = function SvgOval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.643 39.5q-6.476 0-10.989-4.512Q7.144 30.478 7.143 24q0-6.476 4.511-10.988T22.643 8.5h17.714q6.476 0 10.989 4.512 4.51 4.51 4.511 10.988 0 6.476-4.511 10.988T40.357 39.5zm0-4.429h17.714q4.595 0 7.833-3.238Q51.43 28.594 51.43 24q0-4.594-3.239-7.833t-7.833-3.238H22.643q-4.594 0-7.833 3.238Q11.57 19.406 11.57 24q0 4.594 3.239 7.833t7.833 3.238"
  })));
};
export default SvgOval;